// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3e-1";
export var movingGradient = "_3e-4";
export var movingGradientBlock = "_3e-2";
export var skeleton = "_3e-0";
export var skeletonText = "_3e-3";